import { BseDto, SeDto } from "../../autogen/bff-api";

export const eventIsCancelled = (event: BseDto | SeDto): boolean => {
  return event.status === "Cancelled";
};
